module.exports = __webpack_public_path__ + "img/house.a27d93be.svg";